import { Component } from '@angular/core';
import { LookUpsService } from 'src/shared/lookups.service';
import { AdministratorDetails } from 'src/shared/api';
import { Observable } from 'rxjs';

@Component({
	selector: 'rpfsa-landing-page',
	templateUrl: './landing-page.component.html',
})
export class LandingPageComponent {
	administratorDetails$: Observable<AdministratorDetails> = this
		.lookupsService.adminDetails;

	constructor(private readonly lookupsService: LookUpsService) { }
}
